import baseService from '../shared/baseService';

const profileService = () => baseService('profiles');

export default {
    profileService,
};
